import React, { useContext, useEffect, useState } from 'react';
import CollapsedUspModal from './collapsed-usp-modal';
import ExpandedUspModalMobile from './expanded-usp-modal-mobile';
import { UIContext, MediaContext } from '../context';
import { connect, useSelector } from 'react-redux';
import { useUspHotspotSeparate } from '../hooks/useUspHotspotSeparate';
import { capitalize } from './uspUtils';
import { setIncrementClicked, setDecrementClicked, setToggleHotspotView, setHotspotClickedIndex } from '../../../Redux/Reducers/View360Reducer/View360ActionController'

const UspComponentT2MobileExterior = (props) => {
  const { isExpanded, setIsExpanded } = useContext(UIContext);
  const { enterpriseId } = useContext(MediaContext);
  const [isSpanishEnterprise, setIsSpanishEnterprise] = useState(false);
  
  const {
    currentUspIndex,
    currentUsp,
    hotspotData,
    dropdownSelection,
    hotspotClickedIndex,
    handleNext,
    handlePrev,
    handleNextCollapsed,
    handlePrevCollapsed,
    toggleExpand: hookToggleExpand,
    handleHotspotClick,
    toggleHotspotView,
    useAutoCycle
  } = useUspHotspotSeparate(props, 'EXT');
  
  let spanishEnterprises = ['2d410b1b9','204fffd0d']  // TODO: get from backend
  let isSpanishEnterpriseFn = (enterpriseId) => {
      return spanishEnterprises.includes(enterpriseId);
  }
  
  useEffect(() => {
    if(isSpanishEnterpriseFn(enterpriseId)){
      setIsSpanishEnterprise(true);
    }
  }, [enterpriseId])

  useEffect(() => {
    setIsExpanded((hotspotClickedIndex !== -1 && dropdownSelection === "EXT") ? true : false)
  }, [hotspotClickedIndex])

  useAutoCycle(isExpanded);

  const toggleExpand = () => {
    hookToggleExpand(isExpanded, setIsExpanded);
  };

  useEffect(() => {
    if(!props.toggleHotspotView){
      setIsExpanded(false);
    }
  }, [props.toggleHotspotView]);
  
  useEffect(() => {
    if(toggleHotspotView && !isExpanded && dropdownSelection === "EXT") {
      handleHotspotClick(setIsExpanded);
    }
  }, [toggleHotspotView, isExpanded, handleHotspotClick, dropdownSelection]);
  
  return (
    <>
      {hotspotData?.length > 0 && dropdownSelection === "EXT" && (
        <div className={`w-full h-full ${isExpanded ? 'p-4' : 'px-2'}`}>
        {isExpanded ? (
          <ExpandedUspModalMobile
            capitalize={capitalize}
            dropdownSelection={currentUsp?.type || dropdownSelection}
            modalList={currentUsp || {}}
            uspData={currentUsp}
            onClose={toggleExpand}
            onNext={handleNext}
            onPrev={handlePrev}
            hotspotClickedIndex={hotspotClickedIndex}
            currentItemType={currentUsp?.type}
            isSpanishEnterprise={isSpanishEnterprise}
            currentIndex={(currentUspIndex ?? 0) + 1}
            totalItems={hotspotData?.length || 0}
            combinedHotspotData={hotspotData}
            currentUspIndex={currentUspIndex}
          />
        ) : (
          // Mobile-specific collapsed view for exterior
          <div className='w-full h-full bg-blue-500 px-3 py-2 rounded-xl shadow-lg text-white'>
            Exterior Hotspots - Collapsed View
          </div>
        )}
      </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  incrementClicked: state.view360Reducer.incrementClicked,
  decrementClicked: state.view360Reducer.decrementClicked,
  hotspotClickedIndex: state.view360Reducer.hotspotClickedIndex,
  toggleHotspotView: state.view360Reducer.toggleHotspotView
});

const mapDispatchToProps = {
  setIncrementClicked,
  setDecrementClicked,
  setToggleHotspotView,
  setHotspotClickedIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(UspComponentT2MobileExterior);
